import Cook from './Cook'
import Eating from './Eating'
import Grope from './Grope'
import Catch from './Catch'
import Shower from './Shower'
import Holidays from './Holidays'
import Brushing from './Brushing'


export default [Brushing, Eating, Grope, Catch, Shower, Cook, Holidays]